import { render, staticRenderFns } from "./LexonSwitchComponent.vue?vue&type=template&id=61c8c8fe&scoped=true&lang=pug"
import script from "./LexonSwitchComponent.vue?vue&type=script&lang=ts"
export * from "./LexonSwitchComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonSwitchComponent.vue?vue&type=style&index=0&id=61c8c8fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8c8fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c8c8fe')) {
      api.createRecord('61c8c8fe', component.options)
    } else {
      api.reload('61c8c8fe', component.options)
    }
    module.hot.accept("./LexonSwitchComponent.vue?vue&type=template&id=61c8c8fe&scoped=true&lang=pug", function () {
      api.rerender('61c8c8fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonSwitch/LexonSwitchComponent.vue"
export default component.exports